export const DEFAULT_GRID_SIZE = 15;

export const reactApp = () => {
  const params = {
    apiUrl: "",
    clientId: "",
    tenantId: "",
    redirectUri: window.location.origin,
    routerBasename: "/",
    reportsBaseUrl: "",
    reportDomainName: ""
  }
  return params;
};

export enum UserRoles {
  ICD10_OD = 'ICD10_OD',
  ICD10_GM = "ICD10_GM",
  ICD10_CCT = "ICD10_CCT",
  ICD10_CM = "ICD10_CM",
  ICD10_OTHER = "ICD10_OTHER",
  ICD10_DM = "ICD10_DM",
  ICD10_CEC = "ICD10_CEC"
};